/* lua.js generated code 0.3.0 */

FunscareConfig = xClass("FunscareConfig")
FunscareConfig.prototype.getUserInfo = function () {
    var self = this
    var metaInfo = he.MetaInfo.getInstance()
    var user = UserManager.getInstance().user
    var profile = UserManager.getInstance().profile
    var markData = UserManager.getInstance().mark
    var createTime = markData && markData.createTime || 0
    var deviceOS = ""
    var appId = ""
    var secret = ""
    var network = "UNKNOWN"
    var pt = ""
    var name = ""
    var headUrl = "1"
    if (__ANDROID) {
        deviceOS = "android"
        appId = "5002"
        secret = "619521835adaab1456d8f913f4b94090"
        network = luajava.bindClass("com.happyelements.android.MetaInfo").getNetworkTypeName()
        var pts = GameProxy.getInstance().getDefaultSmsPayment()
        var pt = "NOSIM"
        if (pts) {
            pt = PaymentNames[pts]
        }
    } else if (__IOS) {
        deviceOS = "ios"
        appId = "5001"
        secret = "d99d9e26c3ddaa0703ee55d400908db1"
        network = oc.HeReachability.getNetWorkTypeName()
        pt = "apple"
    }
    if (profile && profile.haveName()) {
        name = profile.getDisplayName()
    }
    if (profile && profile.headUrl) {
        headUrl = profile.headUrl
    }
    if (string.match(headUrl, "^%d+$")) {
        var protocal = "http://static.clover"
        if (__IOS) {
            protocal = "https://staticclover"
        }
        headUrl = string.format("%s.happyelements.cn/pic/friendpage/%s.png", protocal, headUrl)
    }
    var userInfo = table()
    userInfo.app = appId
    userInfo.ct = tonumber(createTime) / 1000
    userInfo.ext = ""
    userInfo.gold = user.getCash() || "0"
    userInfo.lang = "zh-Hans"
    userInfo.level = user.getTopLevelId() || ""
    userInfo.lt = PlatformConfig.getLoginTypeName()
    userInfo.mac = metaInfo.getMacAddress() || ""
    userInfo.model = metaInfo.getDeviceModel() || ""
    userInfo.name = name
    userInfo.os = deviceOS
    userInfo.osver = metaInfo.getOsVersion() || ""
    userInfo.pf = he.StartupConfig.getInstance().getPlatformName() || ""
    userInfo.pt = pt
    userInfo.roleavatar = headUrl
    userInfo.roleid = tostring(UserManager.getInstance().inviteCode || "")
    userInfo.rolesid = ""
    userInfo.silver = user.getCoin() || "0"
    userInfo.src = "client"
    userInfo.ts = os.time()
    userInfo.uid = user.uid || ""
    userInfo.udid = metaInfo.getUdid() || ""
    userInfo.uuid = _G.kDeviceID || ""
    userInfo.uver = ResourceLoader.getCurVersion() || ""
    userInfo.ver = _G.bundleVersion
    userInfo.vip = 0
    userInfo.network = network || ""
    userInfo.secret = secret
    for (var k in userInfo) {
        var v = userInfo[k]
        userInfo[k] = tostring(v) || ""
    }
    return userInfo
}
